"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserIdentityReturnUrlStorage = void 0;
var react_use_1 = require("react-use");
var UserIdentityContextProvider_1 = require("./UserIdentityContextProvider");
var useUserIdentityReturnUrlStorage = function () {
    var appId = (0, UserIdentityContextProvider_1.useUserIdentityContext)().appId;
    return (0, react_use_1.useLocalStorage)("user-identity-return-url-".concat(appId));
};
exports.useUserIdentityReturnUrlStorage = useUserIdentityReturnUrlStorage;
//# sourceMappingURL=hooks.js.map